<template>
  <div>
    <Input
      :value="name"
      :clearable="true"
      placeholder="请选择"
      @on-clear="clear"
      ><Button slot="append" icon="md-person" @click="openGroup = true">
      </Button
    ></Input>

    <Drawer
      :placement="placement"
      :closable="false"
      v-model="openGroup"
      width="450"
      draggable
      class="my-drawer"
    >
      <driver-tool @person="rePerson" :filterGroup="filterGroup"></driver-tool>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["name", "placement", "filterGroup"],
  data() {
    return {
      openGroup: false,
    };
  },
  methods: {
    rePerson(v) {
      this.openGroup = false;
      this.$emit("update:id", v.id);
      this.$emit("update:name", v.name);
      this.$emit("update:deviceNo", v.deviceNo);
      this.$emit("person", v);
    },
    clear() {},
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/selectDriver.vue